import styled from "styled-components";

export const StyledGlobals = styled.div`
  /* @import "~@fontsource/roboto/index.css";
  @import "~@fontsource/roboto/300.css";
  @import "~@fontsource/roboto/400.css";
  @import "~@fontsource/roboto/700.css";
  @import "~@fontsource/roboto/900.css"; */

  :root {
    --radio-size: 1.6rem;
    --breakpoint: 1021px;
  }

  html {
    font-size: 62.5%; // sets0.625rem to 10px
    font-family: Roboto;
    background-color: ${({ theme }) => theme.colors.black};
  }

  * {
    font-family: Roboto;
  }

  p,
  h1,
  h2,
  h3,
  span {
    line-height: 1.166;
  }

  p,
  span {
    /* font-size: 0.75rem; */
    /* color: ${({ theme }) => theme.colors.white}; */

    @media (min-width: 1021px) {
      /* font-size: 0.875rem; */
    }
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 900;
  }

  ol,
  ul {
    /* list-style: none;
    list-style-type: none; */
  }

  button {
    outline: unset;
    /* border: unset; */
  }
  :root {
    --radio-size: 1.6rem;
  }

  html {
    font-size: 62.5%;
    font-family: Roboto;
  }

  * {
    font-family: Roboto;
  }

  p,
  h1,
  h2,
  h3,
  span {
    line-height: 1.166;
  }

  h1 {
    font-size: 1.5rem;
    font-weight: 900;
  }

  html {
    min-height: 100vh;
    background-color: lightgray;
  }
`;
